// frontend/src/types/error.types.ts
export enum AuthErrorType {
  INVALID_CREDENTIALS = 'INVALID_CREDENTIALS',
  USER_NOT_FOUND = 'USER_NOT_FOUND',
  NETWORK_ERROR = 'NETWORK_ERROR',
  SESSION_EXPIRED = 'SESSION_EXPIRED',
  UNKNOWN = 'UNKNOWN'
}

export interface AuthError {
  type: AuthErrorType;
  message: string;
}

export interface ApiError {
    message: string;
    code: string;
    status: number;
    details?: Record<string, any>;
  }
  
  export class ApplicationError extends Error {
    constructor(
      public code: string,
      message: string,
      public status: number = 500,
      public details?: Record<string, any>
    ) {
      super(message);
      this.name = 'ApplicationError';
    }
  }